import { TRootState } from "../@types";

export const selectModalCampaigns = (state: TRootState) =>
  state.campaigns.campaignsModalIsOpen;

export const selectIsUpdateCampaign = (state: TRootState) =>
  state.campaigns.isUpdateCampaign;

export const selectCampaignForUpdate = (state: TRootState) =>
  state.campaigns.campaignsForUpdate;

export const selectCampaignsRefreshTable = (state: TRootState) =>
  state.campaigns.refreshTableCampaigns;

export const selectCampaignsProductsRefreshTable = (state: TRootState) =>
  state.campaigns.refreshTableCampaignsProducts;
